<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">

                <!-- Header Specialist (Nume, Buton, Poză) -->
                <div class="row">
                  <div class="col-md-9">
                    <h2>Psiholog Maria Ciocan – Specialist clinician și expert psiholog</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img">
                        <img src="../../../assets/images/team/member-5.jpg" alt="Psiholog Maria Ciocan" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Descriere generală -->
                <p>
                  Sunt <strong>Maria Ciocan</strong>, psiholog specialist clinician și expert psiholog (înscrisă în Registrul experților psihologi), cu o experiență profesională de peste două decenii în domeniul educației și psihologiei. Activitatea mea profesională s-a construit în jurul evaluării psihologice, psihodiagnozei, consilierii și sprijinului acordat copiilor și adulților, cu o atenție aparte acordată persoanelor cu cerințe educaționale speciale, cu tulburări din spectrul autist și persoanelor cu dizabilități.
                </p>
                <p>
                  Consider că fiecare persoană are propriul ritm de dezvoltare, propriile resurse și propriile nevoi, iar rolul meu ca psiholog specialist este de a le identifica și valorifica printr-o abordare profesionistă, empatică și individualizată.
                </p>

                <!-- Servicii oferite -->
                <h3>Servicii psihologice oferite</h3>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Evaluare psihologică clinică și psihodiagnostic
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Consiliere psihologică și educațională
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Evaluarea dezvoltării cognitive, emoționale și comportamentale
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Evaluarea și intervenția psihologică în cazul persoanelor cu TSA
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Psihologie educațională, consiliere școlară și vocațională
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Psihologia muncii și organizațională
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Consiliere psihologică pentru persoane aflate sub supravegherea Serviciului de Probațiune
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Evaluare și expertiză psihologică, în limitele competențelor profesionale atestate
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Elaborarea rapoartelor și documentelor psihologice specifice activității de evaluare și expertiză (DGASPC, CJRAE, Probațiune, Tutelă, etc.)
                  </li>
                </ul>

                <!-- Arii de competență -->
                <h3>Arii de competență</h3>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Psihologie clinică
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Psihologia muncii și organizațională
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Psihologie educațională, consiliere școlară și vocațională
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Evaluare psihologică și psihodiagnostic
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Consiliere psihologică
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Servicii psihologice pentru persoane cu TSA (tulburări din spectrul autist)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Consiliere psihologică pentru persoane aflate sub supravegherea Serviciului de Probațiune
                  </li>
                </ul>

                <!-- Experiență profesională -->
                <h3>Experiență profesională</h3>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>11 februarie 2011 – prezent:</strong> Psiholog specialist cu drept de liberă practică, membru al Colegiului Psihologilor din România – CIP „Ciocan Maria”, Clinica PozitivMedical
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>Septembrie 1998 – prezent:</strong> Profesor psihopedagog, psihodiagnostician la Centrul Școlar de Educație Incluzivă – Negrești (activități de predare-învățare-evaluare, logopedie, psihodiagnoză, consiliere școlară, educațională și profesională)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>Septembrie 2008 – 2019:</strong> Psiholog clinician la Centrul de Asistență Medico-Socială Băcești, județul Vaslui (consiliere și evaluare psihologică, psihoterapie, suport adaptat)
                  </li>
                </ul>

                <!-- Educație și formare profesională -->
                <h3>Educație și formare profesională</h3>
                <p>
                  Formarea profesională continuă reprezintă o componentă esențială a activității mele de psiholog. De-a lungul carierei am urmat programe de perfecționare în domeniul psihologiei clinice, al dezvoltării copilului, autismului, tulburărilor de limbaj și consilierii.
                </p>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>1999 – 2004:</strong> Diplomă de licență, Facultatea de Psihologie și Științe ale Educației, specializarea Psihologie–Pedagogie, Universitatea „Alexandru Ioan Cuza”, Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>Martie 2013:</strong> Curs postuniversitar de perfecționare: <em>Strategii și tehnici psihoterapeutice utilizate în corectarea tulburărilor de limbaj. Abordare interdisciplinară</em>, UMF „Grigore T. Popa”, Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>Aprilie 2013:</strong> Curs postuniversitar de perfecționare: <em>Autismul – etiopatogenie, forme, tablou clinic, paraclinic, evoluție, posibilități terapeutice</em>, UMF „Grigore T. Popa”, Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>Martie 2014:</strong> Curs postuniversitar de perfecționare: <em>Reabilitarea tulburărilor de deglutiție în cazul malformațiilor oro-maxilo-faciale la copil</em>, UMF „Grigore T. Popa”, Iași
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "MariaCiocanPage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>